/** The Able — Kenyan paralympic sport programme (UI; APIs later). */

export const THE_ABLE_ROUTE_NAME = "TheAbleIntro";
export const THE_ABLE_PATH = "/ipromiseafrica/the-able";
export const THE_ABLE_STORE_PATH = "/ipromiseafrica/the-able/equipment";

export const THE_ABLE_CHALLENGES = Object.freeze([
  {
    id: "equipment",
    icon: "fa-solid fa-wheelchair",
    title: "Limited equipment access",
    summary:
      "Wheelchairs, prosthetics, sport-specific aids, and adaptive gear are scarce—many athletes train without the right tools.",
  },
  {
    id: "trainers",
    icon: "fa-solid fa-person-chalkboard",
    title: "Few qualified trainers",
    summary:
      "Coaches and therapists who understand impairment-specific sport are thin on the ground across counties.",
  },
  {
    id: "tournaments",
    icon: "fa-solid fa-trophy",
    title: "Fewer competitive chances",
    summary:
      "Without regular tournaments and fixtures, athletes struggle to build experience, confidence, and visibility.",
  },
]);

export const THE_ABLE_PILLARS = Object.freeze([
  {
    id: "schools",
    icon: "fa-solid fa-school",
    title: "Special school partnerships",
    summary:
      "We partner with special schools to identify talent early, align training with term calendars, and keep families in the loop.",
  },
  {
    id: "gear",
    icon: "fa-solid fa-basketball",
    title: "Adaptive equipment store",
    summary:
      "A dedicated channel on IPA Store for paralympic and adaptive sports equipment—priced and sourced for Kenyan realities.",
  },
  {
    id: "coaches",
    icon: "fa-solid fa-hands-holding-child",
    title: "Trainer network",
    summary:
      "Register as an impairment-aware coach or therapist and get matched to schools and community programmes.",
  },
  {
    id: "fixtures",
    icon: "fa-solid fa-calendar-days",
    title: "Tournaments & fixtures",
    summary:
      "Structured events so athletes gain match experience, scouts see progress, and schools celebrate milestones.",
  },
]);

export const THE_ABLE_SCHOOL_POINTS = Object.freeze([
  "On-site talent identification with school staff and parents",
  "Term-friendly training blocks and safe facility use",
  "Equipment loans and store referrals where budgets are tight",
  "Pathways from school sport to county and national paralympic events",
]);

export const THE_ABLE_TRAINER_PERKS = Object.freeze([
  "List your impairment sport specialties and counties covered",
  "Get introduced to partner special schools",
  "Access IPA training resources and community guidelines",
  "Build a verified profile as adaptive sport grows in Kenya",
]);
